module.exports = {
  // silver: {
  //   label: 'Tathata Golf Coaching Annually',
  //   stripeId: 'silver-yearly',
  //   subtext: '*Limited Quantity',
  //   text:
  //     'In addition to your full Online Membership, enjoy personalized coaching from the Tathata Golf staff. This membership includes 1 swing submittal per month, 1 online follow-up video call per month, and a 20% discount on all Tathata Golf products & training services. $3,000 value if bought separately. ',
  //   basePrice: 149999,
  //   suffix: '/ yr',
  //   period: 'year',
  // },
  gold: {
    label: 'Bryan Hepler Coaching Annually',
    stripeId: 'gold-yearly',
    subtext: '*Limited Quantity',
    text:
      'In addition to your full online membership, enjoy personalized coaching from Bryan Hepler, the Founder of Tathata Golf. You will become one of his personal students and enjoy 1 swing submittal per month, 1 online follow-up video call per month and a 20% discount on all Tathata Golf products & training services. $3,000 value if bought separately. ',
    basePrice: 149999,
    suffix: '/ yr',
    period: 'year',
  },
};



// WEBPACK FOOTER //
// ./src/common/coaching-plans.js